import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import { PostContainer, PostContainerClone } from './styles';

const DraggablePostItem = ({
  postId,
  index,
  shouldDisableDrag,
  isDraggingOver,
  children,
}) => {
  return (
    <Draggable
      draggableId={postId}
      index={index}
      isDragDisabled={shouldDisableDrag}
    >
      {(provided, snapshot) => (
        <>
          <PostContainer
            isDragging={snapshot.isDragging}
            isDraggingOver={isDraggingOver}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...provided.draggableProps}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...provided.dragHandleProps}
            ref={provided.innerRef}
            aria-roledescription="Press space bar to lift the post"
          >
            {children}
          </PostContainer>
          {snapshot.isDragging && (
            <PostContainerClone>{children}</PostContainerClone>
          )}
        </>
      )}
    </Draggable>
  );
};

DraggablePostItem.propTypes = {
  postId: PropTypes.string.isRequired,
  shouldDisableDrag: PropTypes.bool,
  index: PropTypes.number,
  children: PropTypes.node.isRequired,
  isDraggingOver: PropTypes.bool,
};

DraggablePostItem.defaultProps = {
  shouldDisableDrag: false,
  index: 0,
  isDraggingOver: false,
};

export default DraggablePostItem;
